<svg class="roulette-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
   <circle cx="12" cy="12" r="10"></circle>
   <path d="M12 2v4"></path>
   <path d="M12 18v4"></path>
   <path d="M22 12h-4"></path>
   <path d="M6 12H2"></path>
   <path d="m19.78 4.22-2.12 2.12"></path>
   <path d="m8.34 15.66-2.12 2.12"></path>
   <path d="m19.78 19.78-2.12-2.12"></path>
   <path d="m8.34 8.34-2.12-2.12"></path>
   <circle cx="12" cy="12" r="1"></circle>
</svg>
<style>
  .roulette-icon {
    /* animation: spinSimple 3s linear infinite; */ 
  }
  /* @keyframes spinSimple {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  } */
</style>